import { IFormErrors } from '@interfaces/IFormsErrors';

export interface ICompaniesChangesState {
  isLoading: boolean;
  success: boolean;
  errors: IFormErrors | null;
}

export const initialCompaniesChangesState: ICompaniesChangesState = {
  isLoading: false,
  success: false,
  errors: null,
};
